export default (api) => {
    return {
        challenge_skill_structure: {
            get: options => api.get('pam/challenge_skill_structure', options)
        },
        student_skill_data: {
            get: options => api.get('pam/student_skill_data', options)
        },
        evaluation_progress: {
            get: options => api.get('pam/evaluation_progress', options)
        },
        practices: {
            get: options => api.get('pam/practices', options)
        }
    }
}
